import type { Auth0UserLike } from '../../types/auth0-user.type'

import { getProfileValue } from './getProfileValue'
import { isEmailLike } from './isEmailLike'

type FullNameParts = {
  firstName: string
  lastName: string
}

const splitFullName = (fullName: string): FullNameParts => {
  const [firstName = '', ...rest] = fullName.split(' ').filter(Boolean)

  return {
    firstName,
    lastName: rest.join(' '),
  }
}

export const getFullName = (auth0User: Auth0UserLike): FullNameParts => {
  const fullName = getProfileValue(auth0User.profile?.name, auth0User.name)

  if (isEmailLike(fullName)) {
    return {
      firstName: '',
      lastName: '',
    }
  }

  return splitFullName(fullName)
}
